import api from './api';

export const fabricSewingTypeAPI = {
  // Get all fabric sewing types
  getAll: (params = {}) => {
    return api.get('/fabric-sewing-types', { params });
  },

  // Get active fabric sewing types only
  getActive: () => {
    return api.get('/fabric-sewing-types/active');
  },

  // Get single fabric sewing type
  getOne: (id) => {
    return api.get(`/fabric-sewing-types/${id}`);
  },

  // Create new fabric sewing type
  create: (data) => {
    return api.post('/fabric-sewing-types', data);
  },

  // Update fabric sewing type
  update: (id, data) => {
    return api.put(`/fabric-sewing-types/${id}`, data);
  },

  // Delete fabric sewing type
  delete: (id) => {
    return api.delete(`/fabric-sewing-types/${id}`);
  },
};
